import { useDispatch, useSelector } from 'react-redux';
import { toggleRole } from '../../../../redux/roleSlice';
import { ButtonBase, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import styles from './RoleToggle.module.css';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

const RoleToggle = ({ mode, isNormalMerchantMode }) => {
    const dispatch = useDispatch();
    const role = useSelector((state) => state.role.role);
    const handleToggle = () => {
        dispatch(toggleRole());
    };

    const isMerchant = role === 'Merchant';
    useEffect(() => {
        if (isNormalMerchantMode && role !== 'Merchant') {
            handleToggle();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            {isNormalMerchantMode ? null : (
                <motion.div
                    initial={{ opacity: 0, y: -10, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    transition={{
                        duration: 0.4,
                        type: 'spring',
                        stiffness: 300,
                        damping: 25
                    }}
                    className={styles.container}
                >
                    <ButtonBase
                        onClick={handleToggle}
                        className={`${styles.toggleSwitch} ${mode === 'dark' ? styles.dark : styles.light}`}
                        disableRipple
                    >
                        {/* Labels */}
                        <Box className={styles.labelsContainer}>
                            <Typography
                                className={`${styles.label} ${styles.leftLabel} ${isMerchant ? styles.activeLabel : styles.inactiveLabel}`}
                                sx={{
                                    fontFamily: '"Inter", "SF Pro Display", -apple-system, sans-serif',
                                    letterSpacing: '-0.01em'
                                }}
                            >
                                Merchant
                            </Typography>
                            <Typography
                                className={`${styles.label} ${styles.rightLabel} ${
                                    !isMerchant ? styles.activeLabel : styles.inactiveLabel
                                }`}
                                sx={{
                                    fontFamily: '"Inter", "SF Pro Display", -apple-system, sans-serif',
                                    letterSpacing: '-0.01em'
                                }}
                            >
                                BC Agent
                            </Typography>
                        </Box>

                        {/* Toggle Track */}
                        <div className={`${styles.track} ${mode === 'dark' ? styles.trackDark : styles.trackLight}`}>
                            {/* Toggle Thumb */}
                            <motion.div
                                className={`${styles.thumb} ${mode === 'dark' ? styles.thumbDark : styles.thumbLight}`}
                                animate={{
                                    x: isMerchant ? 2 : 90,
                                    scale: [1, 1.1, 1]
                                }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 400,
                                    damping: 30,
                                    scale: { duration: 0.15 }
                                }}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            />

                            {/* Active indicator inside track */}
                            <motion.div
                                className={`${styles.activeIndicator} ${mode === 'dark' ? styles.indicatorDark : styles.indicatorLight}`}
                                animate={{
                                    x: isMerchant ? 0 : '100%',
                                    opacity: 1
                                }}
                                transition={{
                                    type: 'spring',
                                    stiffness: 300,
                                    damping: 30
                                }}
                            />
                        </div>
                    </ButtonBase>
                </motion.div>
            )}
        </>
    );
};

export default RoleToggle;
RoleToggle.propTypes = {
    mode: PropTypes.string,
    isNormalMerchantMode: PropTypes.bool
};
